import React from 'react'
import _ from 'underscore'
import {
  Select as UISelect,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'

// Radix reserves value="" for "no selection", so the legacy placeholder/empty
// option is mapped to this sentinel and translated back to '' in onChange.
const EMPTY = '__none'

class Select extends React.Component {

  onChange = (value) => {
    // Legacy was a native <select>, so callers always received strings
    // (numeric option values included) and '' for the placeholder option.
    this.props.onChange(value === EMPTY ? '' : value)
  }

  render() {
    const options = this.props.options || []
    const raw = this.props.value
    const hasPlaceholder = !this.props.no_placeholder

    let value
    if (raw === undefined || raw === null || raw === '') {
      value = hasPlaceholder ? EMPTY : undefined
    }
    else {
      value = `${raw}`
    }

    return (
      <UISelect value={value} onValueChange={this.onChange} name={this.props.name}>
        <SelectTrigger className="w-full">
          <SelectValue placeholder={this.props.placeholder}/>
        </SelectTrigger>
        <SelectContent>
          {hasPlaceholder ?
            <SelectItem value={EMPTY}>{this.props.placeholder}</SelectItem>
            : null
          }
          {_.map(options, (option) => {
            const optionValue = (option[0] === '' || option[0] === undefined || option[0] === null) ? EMPTY : `${option[0]}`
            return (
              <SelectItem key={option[0]} value={optionValue}>
                {option[1]}
              </SelectItem>
            )
          })}
        </SelectContent>
      </UISelect>
    )
  }
}

export default Select
